// Sandbox e produção gravam cookies próprios no mesmo `.abbiamolog.com`. Sem
// prefixo, abrir o painel de sandbox apagava a marca ativa da produção e o
// logout do sandbox derrubava as abas de produção. Produção não define
// NX_COOKIE_NAMESPACE, então lá os nomes continuam os de sempre.
export const namespacedCookieName = (name: string): string => {
  const namespace = process.env['NX_COOKIE_NAMESPACE'];
  return namespace ? `${namespace}.${name}` : name;
};
